/*
 * @Author: zhuyating 
 * @Date: 2023-06-08 
 */
import {
  goTo,
  getGoToParams,
  build,
  query,
  is,
  bridge,
  weixinReady,
  alipayReady
} from '@didi/webx-js';
import { mpx } from '@didi/es-mpx-creator';
import store from '@/store';
import { isWXMini, isALIMini } from './constant'
/**
 * 页面之间跳转
 * @param {*} link
 * @param {*} options
 */
const jump = (link, options = {}) => {
  const { params, h5JumpMethod, moveType = 0, sameProduct = false } = options;
  const commonParams = {}
  const goToParams = {
    url: '',
    path: '',
    params: {
      ...commonParams,
      ...params
    },
    extParams: {
      sameProduct: sameProduct,
      moveType: moveType,
      h5JumpMethod: h5JumpMethod
    }
  };
  if (/^(\/[a-zA-Z]+)+/.test(link)) {
    goToParams.path = link
  } else {
    goToParams.url = link
  }

  if (h5JumpMethod === 'replace' && goToParams.url) {
    replaceJump(goToParams.url, goToParams.params);
  } else {
    goTo(goToParams);
  }
}

/**
 * 内部跳转公共参数
 * @param {*} options
 */
const innerCommonParams = () => {
  const {
    appid = '',
    openid,
    open_id,
    xcx_openid,
    city_id,
    cityid,
    cityId,
    pre_prod_key,
    home_tab,
    hide_flights
  } = query();
  const params = { appid, pre_prod_key, home_tab, hide_flights }
  if (!is('passenger')) {
    params.openid = openid || open_id || xcx_openid
  }
  params.city_id = city_id || cityid || cityId;
  return {
    ...params,
    ...getWebxParams()
  }
}

/**
 * 上报到后端日志参数
 * @param {*} options
 */
export const trackingInfo = () => {
  const {
    city_id,
    cityid,
    cityId
  } = query();
  const { xpsid, dchn, xenv, xpsid_root } = store.state.common.xpsmInfo;
  const { cityId: city } = store.state.common.locationInfo;
  const biz_from = store.state.common.bizFrom;
  const guide_trace_id = store.state.common.guideTraceId;
  console.log('common.locationInfo', store.state.common.locationInfo);
  return {
    city_id: city_id || cityid || cityId || city,
    xpsid,
    dchn,
    xenv,
    xpsid_root,
    biz_from,
    guide_trace_id
  };
};

/**
 * replace 封装九章参数
 * @param {*} url
 * @param {*} options
 */
export const replaceJump = (url, options = {}) => {
  const option = {
    sameProduct: true,
  }
  const extParams = getGoToParams(option)
  window.location.replace(build(url, { ...extParams, ...options }))
}

// 页面路由信息
export const pagePath = () => {
  const innerPath = {
    HOME: '/pages/home/index',
    VERIFICATIONCODE: '/pages/login12306/verification-code',
    WITNESSVERIFICATION: '/pages/login12306/witness-verification',
    LOGIN12306: '/pages/login12306/index',
    PASSWORDMODIFICATION: '/pages/login12306/password-modification',
    LOGIN12306SUBMIT: '/pages/login12306/submit-rm',
    REGISTER: '/pages/login12306/register',
    TRAINCITY: '/pages/train-city/index',
    TRAINDETAIL: '/pages/train-detail/index',
    UPLOAD: '/pages/upload',
    JUMP: '/pages/jump',
    AGREEMENT: '/pages/agreement/index',
    WEBVIEW: '/pages/webview',
    PAGESINDEX: '/pages/index',
    PAGESSUCCESS: '/pages/success',
    MAKEORDER: '/pages/make-order/index',
    MAKEORDERBACKUP: '/pages/make-order/index-backup',
    PASSWORDRETRIEVAL: '/pages/login12306/password-retrieval',
    COMPONENTDEMO: '/pages/component-demo',
    REFUNDTICKETPAGE: '/pages/refund-ticket/refund-ticket-page',
    REFUNDTICKETDETAILPAGE: '/pages/refund-ticket/refund-ticket-detail-page',
    CHANGETICKETPAGE: '/pages/change-ticket/change-ticket-page',
    CHANGETICKETDETAILPAGE: '/pages/change-ticket/change-ticket-detail-page',
    SEARCHLIST: '/pages/search/list',
    ORDERDETAIL: '/pages/order/detail',
    OCCUPYFAILED: '/pages/order/occupy-failed', // 占座失败
    ORDERSEND: '/pages/order/send',
    HOMESERVICE: '/pages/home/service',
    CONTACTSELECT: '/pages/contact/select', // 选择乘车人页面
    CONTACTADD: '/pages/contact/add', // 添加乘车人页面
    CONTACTEDIT: '/pages/contact/edit', // 编辑乘车人页面
    CONTACTSELECTCOUNTRY: '/pages/contact/selectCountry', // 选择国家或地区
    CONTACTLIST: '/pages/contact/list', // 联系人列表页
    ORDERLIST: '/pages/order-list/index', // 订单列表
    ICKETPURCHASENOTICE: '/pages/ticket-purchase-notice/index', // 购票须知页面
    CONTACTVERIFYPAGE: '/pages/passenger/passenger-contact-verify-page',
    IDENTITYVERIFYPAGE: '/pages/passenger/passenger-identity-verify-page',
    REFUNDOFFLINE: '/pages/order/refund-offline', // 私退私改页面
    TICKETS12306LIST: '/pages/tickets12306/order-list',
    TICKETS12306DETAIL: '/pages/tickets12306/order-detail',
    SHARE: '/pages/share/index',
  };
  // Object.keys(innerPath).map((item) => {
  //   innerPath[item] = host + innerPath[item];
  // });
  return innerPath;
}

// 获取origin
export const getCurrentOrigin = () => {
  if (__mpx_mode__ === 'web') {
    const { protocol, host } = window.location
    return `${protocol}//${host}`
  }
  return 'https://railway.xiaojukeji.com'
}

// e.g. /pages/home/index
const getCurrentPathName = () => {
  if (__mpx_mode__ === 'web') {
    return window.location.pathname
  }
  return ''
}

// 兼容支付宝ios首页跳转其他页面后侧滑回退直接退出
const compatibleAlipayRouter = () => {
  const pathname = getCurrentPathName()
  return pathname === '/pages/home/index' && is('ios.alipay')
}

// 获取九章参数
const getWebxParams = () => {
  return getGoToParams({
    sameProduct: true
  });
};

class Router {
  constructor() { }

  redirect(url, options) {
    mpx.$mpxRouter.redirect(url, { ...options, ...innerCommonParams() });
  }
  push(url, options) {
    if(compatibleAlipayRouter()) {
      const _url = `${getCurrentOrigin()}${url}`
      const _params = {
        ...options,
        ...innerCommonParams(),
        __aliwebview: 1
      }
      this.goTo(_url, _params, {})
    }else {
      mpx.$mpxRouter.push(url, { ...options, ...innerCommonParams() });
    }
  }

  replace(url, options) {
    mpx.$mpxRouter.replace(url, { ...options, ...innerCommonParams() });
  }

  goback(delta = 1) {
    mpx.$mpxRouter.goback(delta);
  }

  goTo(url, options, extParams) {
    return jump(url, {
      params: options,
      ...extParams
    });
  }

  mpReplace(url, options) {
    if (isWXMini || isALIMini) {
      this.redirect(url, options)
    } else {
      this.replace(url, options)
    }
  }
}

export const innerRouter = new Router();

/**
 * 关闭当前webview
 * @param {*} options
 */
export const closePage = options => {
  const { historyBack, fromHash } = options || {}
  if (__mpx_mode__ === 'web') {
    const hasReferrer = !!document.referrer
    const isReloadFromC = document.referrer.indexOf(location.origin) > -1 // 大C切环境导致无法回退
    if (hasReferrer && !isReloadFromC) {
      history.go(-1)
      return
    }
    if (fromHash) {
      window.history.back()
      return
    }
    if (is('miniprogram') && is('weixin') && !historyBack) {
      // 小程序内嵌h5
      weixinReady(wx => {
        wx &&
          wx.miniProgram.navigateBack({
            delta: 1,
          })
      })
      return
    } else if (is('miniprogram') && is('alipay')) {
      alipayReady(AlipayJSBridge => {
        AlipayJSBridge && AlipayJSBridge.call('popWindow');
      });

    } else if (is('passenger')) {
      bridge.closePage && bridge.closePage({}, () => { })
    } else {
      history.go(-1);
    }
  }
  if (__mpx_mode__ === 'wx') {
    wx.navigateBack({
      delta: 1,
    })
  }
}
